<template>
  <div>
    <dialog-wrapper v-if="isAdmin"
                    :title="$t('userManual')"
                    max-width="520px"
                    not-scrollable
                    @open="onOpen">
      <template v-slot:activator="{open}">
        <v-btn text
               icon
               @click="open">
          <v-icon>
            mdi-help-circle-outline
          </v-icon>
        </v-btn>
      </template>

      <v-row dense>
        <v-col cols="12">
          <v-text-field :value="currentFileLabel"
                        :label="$t('currentManual')"
                        readonly
                        hide-details />
        </v-col>
        <v-col cols="12">
          <v-text-field :value="selectedFileLabel"
                        :label="$t('newFile')"
                        readonly
                        hide-details
                        append-icon="mdi-paperclip"
                        @click="triggerFileDialog" />
        </v-col>
      </v-row>

      <template v-slot:actions="{close}">
        <v-btn text
               color="primary"
               :href="downloadUrl"
               :disabled="!manualInfo"
               download>
          {{$t('download')}}
        </v-btn>
        <v-spacer />
        <v-btn text
               color="primary"
               @click="onCancel(close)">
          {{$t('cancel')}}
        </v-btn>
        <v-btn color="primary"
               :loading="saving"
               :disabled="!selectedFile"
               @click="onSave(close)">
          {{$t('save')}}
        </v-btn>
      </template>
    </dialog-wrapper>
    <v-tooltip v-else
               bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs"
               text
               icon
               :href="downloadUrl"
               download
               v-on="on">
          <v-icon>
            mdi-help-circle-outline
          </v-icon>
        </v-btn>
      </template>
      <span>{{$t('downloadUserManual')}}</span>
    </v-tooltip>

    <input ref="fileInput"
           type="file"
           accept="application/pdf"
           hidden
           @change="onFileSelect($event.target.files)">
  </div>
</template>

<script>
import DialogWrapper from '@/components/DialogWrapper.vue';

export default {
  name: 'UserManualButton',
  components: {DialogWrapper},
  data () {
    return {
      manualInfo: null,
      selectedFile: null,
      saving: false,
    };
  },
  computed: {
    isAdmin () {
      return this.$isGranted('ROLE_ADMIN');
    },
    downloadUrl () {
      return `${this.API.getBaseUrl()}/user-manual`;
    },
    currentFileLabel () {
      if (!this.manualInfo) {
        return this.$t('noManualUploaded');
      }
      return this.manualInfo.originalFileName || this.manualInfo.id;
    },
    selectedFileLabel () {
      return this.selectedFile ? this.selectedFile.name : this.$t('fileNotSelected');
    },
  },
  methods: {
    async onOpen () {
      this.selectedFile = null;
      await this.loadInfo();
    },
    async loadInfo () {
      const {data} = await this.API.get(['user-manual', 'info']);
      this.manualInfo = data || null;
    },
    onFileSelect (files) {
      this.selectedFile = files?.[0] || null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },
    triggerFileDialog () {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    async onSave (close) {
      if (!this.selectedFile) {
        return;
      }
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      try {
        this.saving = true;
        const {data} = await this.API.post(['user-manual'], formData, {
          headers: {'Content-Type': 'multipart/form-data'},
        });
        this.manualInfo = data;
        this.selectedFile = null;
        await this.$store.dispatch('snackbar/add', {color: 'success', content: 'saved'});
        close();
      } finally {
        this.saving = false;
      }
    },
    onCancel (close) {
      this.selectedFile = null;
      close();
    },
  },
};
</script>

<style scoped>
</style>
